var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenEmailInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100.000000pt",
    height: "100.000000pt",
    viewBox: "0 0 100.000000 100.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,100.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435 983 c-16 -8 -45 -29 -63 -47 -31 -29 -39 -31 -120 -36 l-87 -5 -3 -72 -3 -72 -80 -72 -79 -71 2 -302 3 -301 495 0 495 0 3 301 2 302 -79 71 -80 72 -3 72 -3 72 -87 5 c-81 5 -89 7 -120 36 -66 63 -132 79 -193 47z m114 -37 c15 -8 33 -22 40 -30 12 -14 3 -16 -88 -16 -109 0 -116 5 -57 41 37 23 67 24 105 5z m251 -285 l0 -198 -59 -47 c-33 -25 -63 -46 -68 -46 -5 0 -24 13 -43 29 -97 79 -163 79 -258 1 -20 -16 -40 -30 -45 -30 -5 0 -35 21 -68 46 l-59 47 0 198 0 199 300 0 300 0 0 -199z m-642 -116 l-3 -45 -58 45 -57 46 57 50 58 51 3 -51 c2 -29 2 -72 0 -96z m746 96 l55 -50 -47 -39 c-76 -62 -72 -64 -72 42 0 53 2 96 5 96 3 0 29 -22 59 -49z m-731 -206 c64 -49 115 -93 114 -97 -1 -4 -57 -50 -124 -102 l-123 -96 0 196 c0 108 4 194 8 192 5 -1 61 -43 125 -93z m787 -100 l0 -195 -122 96 c-68 53 -124 99 -125 103 -2 7 227 189 240 190 4 1 7 -87 7 -194z m-394 59 c21 -15 119 -89 217 -166 143 -112 177 -144 177 -164 l0 -24 -460 0 -460 0 0 24 c0 20 34 52 178 164 219 173 248 192 282 192 15 0 45 -12 66 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431 726 c-58 -58 -70 -86 -38 -86 6 0 28 17 49 37 l38 37 0 -97 c0 -90 1 -97 20 -97 19 0 20 7 20 97 l0 97 38 -37 c39 -38 56 -45 68 -26 6 10 -111 139 -126 139 -3 0 -34 -29 -69 -64z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEmailInbox);
export default __webpack_public_path__ + "static/media/open-email-inbox.4544999edb81f7506d9aebb27b989cf1.svg";
export { ForwardRef as ReactComponent };